
import { computed, ComputedRef, defineComponent, Ref, ref } from 'vue';

export default defineComponent({
  name: 'ZoomableImage',
  components: {},
  props: {
    src: String,
    alt: Number,
  },
  setup() {
    const isZoomed: Ref<boolean> = ref<boolean>(false);
    const xPosition: Ref<number> = ref<number>(50);
    const yPosition: Ref<number> = ref<number>(50);

    const imageStyles: ComputedRef<{}> = computed<{}>(() => {
      return {
        cursor: isZoomed.value ? 'zoom-out' : 'zoom-in',
        'object-fit': isZoomed.value ? 'none' : 'contain',
        'object-position': isZoomed.value ? `${xPosition.value}% ${yPosition.value}%` : '50% 50%',
      };
    });

    const onImageHover = (event: MouseEvent) => {
      const target: HTMLImageElement | null = event.target as HTMLImageElement;
      if (target) {
        xPosition.value = (event.offsetX / target.offsetWidth) * 100;
        yPosition.value = (event.offsetY / target.offsetHeight) * 100;
      }
    };

    const onToggleZoom = () => {
      isZoomed.value = !isZoomed.value;
    };

    return {
      onImageHover,
      onToggleZoom,
      imageStyles,
    };
  },
});
